const badges = [
  { icon: 'ri-medal-line', label: 'Proven Quality', desc: 'Premium-grade materials built to last' },
  { icon: 'ri-tools-line', label: 'Expert Setup', desc: 'Trained crew handling every installation' },
  { icon: 'ri-shield-check-line', label: 'Fully Certified', desc: 'Fire rated & internationally compliant' },
];

export default function Intro() {
  return (
    <section className="py-20 bg-white border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <p className="text-xl md:text-2xl font-bold text-gray-900 leading-relaxed mb-14">
          From intimate gatherings to large-scale festivals, Pop Pro Tents® delivers quality, creativity, and professionalism at every event.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {badges.map((badge, i) => (
            <div
              key={i}
              className="flex items-center gap-4 bg-gray-50 rounded-xl px-6 py-5"
            >
              <div className="w-12 h-12 bg-teal-50 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className={`${badge.icon} text-2xl text-teal-400`}></i>
              </div>
              <div className="text-left">
                <h3 className="font-bold text-gray-900 text-sm">{badge.label}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{badge.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
